import { createContext } from 'react'
import { Rollouts } from './getRollouts'

export const RolloutsContext = createContext<Rollouts>({
  newSearch: false,
})
